import { call, put, takeEvery } from "redux-saga/effects"

import { GET_INVOICES, ADD_NEW_INVOICE, UPDATE_INVOICE, DELETE_INVOICE } from "./actionTypes";
import {
    getInvoicesSuccess,
    getInvoicesFail,
    addInvoiceSuccess,
    addInvoiceFail,
    updateInvoiceSuccess,
    updateInvoiceFail,
    deleteInvoiceSuccess,
    deleteInvoiceFail,
   
} from "./actions"

import {
    getInvoices,
    addNewInvoice,
    updateInvoice,
    deleteInvoice,
   
} from "helpers/purchases/purchases_backend_helper";
import { toast } from "react-toastify";

function* fetchInvoices() {
    try {
        const response = yield call(getInvoices)
        yield put(getInvoicesSuccess(response))
    } catch (error) {
        yield put(getInvoicesFail(error))
    }
}

function* onAddNewInvoice({ payload: data }) {
    try {
        const response = yield call(addNewInvoice, data)
        yield put(addInvoiceSuccess(response))
        toast.success("Event  Added Successfully", { autoClose: 2000 });
    } catch (error) {
        yield put(addInvoiceFail(error))
        toast.error("Event  Added Failed", { autoClose: 2000 });
    }
}

function* onUpdateInvoice({ payload: data }) {
    try {
        const response = yield call(updateInvoice, data)
        yield put(updateInvoiceSuccess(response))
        toast.success("Event  Updated Successfully", { autoClose: 2000 });
    } catch (error) {
        yield put(updateInvoiceFail(error))
        toast.error("Event  Updated Failed", { autoClose: 2000 });
    }
}

function* onDeleteInvoice({ payload: data }) {

    try {
        const response = yield call(deleteInvoice, data)
        yield put(deleteInvoiceSuccess(response))
        toast.success("Event  Deleted Successfully", { autoClose: 2000 });
    } catch (error) {
        yield put(deleteInvoiceFail(error))
        toast.error("Event  Deleted Failed", { autoClose: 2000 });
    }
}


function* invoiceSaga() {
    yield takeEvery(GET_INVOICES, fetchInvoices)
    yield takeEvery(ADD_NEW_INVOICE, onAddNewInvoice)
    yield takeEvery(UPDATE_INVOICE, onUpdateInvoice)
    yield takeEvery(DELETE_INVOICE, onDeleteInvoice)
}

export default invoiceSaga;